<template>
  <fragment>
    <div class="row location-search-container__search floating-label">
      <div class="col-12">
        <span class="pill large">
          <label class="location-search-label">{{ placeholder }}</label>
          <gmap-autocomplete ref="place" type="search" :select-first-on-enter="true" @place_changed="setPlace"
            aria-label="Search" placeholder="" aria-describedby="search-by-location-autocomplete"
            @blur="toggleLabel($event)" @focus="toggleLabel($event)"
            :options="{ bounds: { north: 39.5, south: 27.3, east: -83.52, west: -98.88 }, strictBounds: true }" />
          <button v-on:click="setPlaceBySubmit" class="location-search-container__filters-search"><img
              src="/Static/assets/images/search_icon_red.svg" alt="search" /></button></span>
        <p class="sr-only" id="search-by-location-autocomplete">Segin typing to search, the field will be completed as you type. Use arrow keys to navigate, Enter to select.</p>
      </div>
    </div>
    <div v-if="!selectedLocation" class="row location-search-container__filters">
      <div class="location-dropdown col-12 col-md-4" @click="showDistanceFilter = !showDistanceFilter">
        <button v-bind:class="{ 'pill large': true, 'selected': distance != 'all' }" type="button"
          @click="showDistanceDropdown = !showDistanceDropdown" id="distance-filter" aria-controls="distance-select"
          :aria-expanded="showDistanceDropdown ? 'true' : 'false'">

          <span class="sr-only">Select </span>{{ distancePlaceholder }}
          <span class="caret"></span>
        </button>
        <fieldset class="selection showselect" id='distance-select' aria-labelledby="distance-filter"
          v-if="showDistanceDropdown"
          v-click-outside="{ 'method': hideDistanceFilter, 'except': ['distance-filter', 'distance-select'] }">
          <legend class="sr-only">Distance Filter</legend>
          <div class="col-12 selection__radio" v-for="(distanceOption) in distanceOptions" :key="distanceOption.text">
            <input :id="distanceOption.value2" type="radio" v-model="distance" :value="distanceOption.value"
              name="distance-filter-select" @keyup.space="showDistanceDropdown = false; applyRadius();" />
            <label :for="distanceOption.value2" @click="triggerDistanceFilter(distanceOption.value)"><span
                class="checkmark fas fa-check" aria-hidden="true"></span>{{ distanceOption.text }}</label>
          </div>
        </fieldset>
      </div>


      <div class="location-dropdown col-12 col-md-4" @click="showHoursFilter = !showHoursFilter">
        <button v-bind:class="{ 'pill large': true, 'selected': hours != null }" type="button"
          @click="showHoursDropdown = !showHoursDropdown" id="hours-filter" aria-controls="hours-select"
          :aria-expanded="showHoursDropdown ? 'true' : 'false'">

          <span class="sr-only">Select </span>{{ hoursPlaceholder }}
          <span class="caret"></span>
        </button>
        <fieldset class="selection showselect" id='hours-select' aria-labelledby="hours-filter" v-if="showHoursDropdown"
          v-click-outside="{ 'method': hideHoursFilter, 'except': ['hours-filter', 'hours-select'] }">
          <legend class="sr-only">Hours Filter</legend>
          <div class="col-12 selection__radio">
            <input id="openNow" type="radio" v-model="hours" value="now" name="hours-filter-select"
              @keyup.space="showHoursDropdown = false; applyFilters();" />
            <label for="openNow" @click="triggerHoursFilter('now')"><span class="checkmark fas fa-check"
                aria-hidden="true"></span>Open Now</label>
          </div>
          <div class="col-12 selection__radio">
            <input id="openSaturdays" type="radio" v-model="hours" value="saturdays" name="hours-filter-select"
              @keyup.space="showHoursDropdown = false; applyFilters();" />
            <label for="openSaturdays" @click="triggerHoursFilter('saturdays')"><span class="checkmark fas fa-check"
                aria-hidden="true"></span>Open Saturdays</label>
          </div>
        </fieldset>
      </div>


      <div class="location-dropdown col-12 col-md-4" @click="showServicesFilter = !showServicesFilter">
        <button v-bind:class="{ 'pill large': true, 'selected': meta != null }" type="button"
          @click="showServicesDropdown = !showServicesDropdown" id="services-filter" aria-controls="services-select"
          :aria-expanded="showServicesDropdown ? 'true' : 'false'">
          <span class="sr-only">Select</span> {{ servicesPlaceholder }}
          <span class="caret"></span>
        </button>
        <fieldset class="selection showselect" id='services-select' aria-labelledby="services-filter"
          v-if="showServicesDropdown"
          v-click-outside="{ 'method': hideServicesFilter, 'except': ['services-filter', 'services-select'] }">
          <legend class="sr-only">Services Filter</legend>
          <div class="col-12 selection__radio" v-for="(filterOption) in serviceFilters" :key="filterOption.text">
            <input :id="filterOption.value2" type="radio" v-model="meta" :value="filterOption.value"
              name="services-filter-select" @keyup.space="showServicesDropdown = false; applyFilters();" />
            <label :for="filterOption.value2" @click="triggerServicesFilter(filterOption.value)"><span
                class="checkmark fas fa-check" aria-hidden="true"></span>{{ filterOption.text }}</label>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="row row location-search-container__locations">
      <div class="col-12 col-md-8">
        <a class="btn-arrow" href="https://www.moneypass.com/atm-locator.html" target="_blank">Find MoneyPass ATM
          Locations</a>
      </div>
      <div class="col-12 col-md-4 location-search-container__reset-filters" v-if="hasFilters">
        <a href="javascript:;" class="link" @click="clearFilters">Reset Filters</a>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapActions } from "vuex";
import EventBus from "../functions/eventBus";
import { defaultOpt } from "../../../config/map";
import { locText } from "../../../utils/useText";
import { capitalizeString } from "../../../utils/functions";
import * as VueGoogleMaps from "vue2-google-maps";
import { setStateFromLocalStore } from '../store/localStore';
export default {
  created() {
    EventBus.$on("clearSearch", () => {
      this.clearSearch();
    });


  },
  data() {
    return {
      distanceOptions: [
        {
          text: "All",
          value: "all",
          value2: "valueALL"
        },
        {
          text: "Within 5 miles",
          value: "5",
          value2: "valueFive"
        },
        {
          text: "Within 20 miles",
          value: "20",
          value2: "valueTwenty"
        },
        {
          text: "Within 50 miles",
          value: "50",
          value2: "valueFifty"
        },
      ],
      distance: "all",
      searchTerm: null,
      serviceFilters: [
        {
          text: "ATM",
          value: "atm",
          value2: "valueATM"
        },
        {
          text: "Quick Deposit ATM",
          value: "quickDeposit",
          value2: "valueQuickDeposit"
        },
        {
          text: "Drive-Thru",
          value: "driveThru",
          value2: "valueDrive-Thru"
        },
        {
          text: "Full Service",
          value: "fullService",
          value2: "valueFullService"
        },
        {
          text: "Instant Issue Debit Card",
          value: "instantIssueDebitCard",
          value2: "valueInstantIssueDebitCard"
        },
        {
          text: "Safe Deposit Boxes",
          value: "safeDepositBoxes",
          value2: "valueSafeDepositBoxes"
        }
      ],
      showDistanceFilter: false,
      showDistanceDropdown: false,
      showHoursFilter: false,
      showHoursDropdown: false,
      showServicesFilter: false,
      showServicesDropdown: false,
      hours: null,
      meta: null
    };
  },
  components: {
    "gmap-autocomplete": VueGoogleMaps.Autocomplete
  },
  mounted() {
    this.distance = this.userDistance ? this.userDistance : "all";
    this.hours = this.userHours ? this.userHours : null;
    this.meta = this.userMeta ? this.userMeta : null;

    setStateFromLocalStore(this);
  },
  computed: {
    distancePlaceholder: {
      get() {
        var placeholder = this.text("distancePlaceholder");

        if (this.distance && this.distance != "all") {
          // placeholder = this.distanceOptions.find(el => el.value == this.distance).text;
          placeholder = capitalizeString(this.distance) + (this.distance != "all" ? " " + this.text("distance") : "");
        }
        return placeholder;
      }
    },
    hasFilters() {
      return this.userDistance != "all" || (this.userHours && this.userHours.length >= 1) || (this.userMeta && this.userMeta.length >= 1);
    },
    hoursPlaceholder: {
      get() {
        var placeholder = this.text("hoursPlaceholder");

        if (this.hours) {
          placeholder = capitalizeString(this.hours);
        }

        return placeholder;
      }
    },
    servicesPlaceholder: {
      get() {
        var placeholder = this.text("servicesPlaceholder");

        if (this.meta) {
          placeholder = this.serviceFilters.find(el => el.value == this.meta).text;
        }

        return placeholder;
      }
    },
    placeholder() {
      return this.current ? this.searchTerm : this.text('locationsPlaceholder');
    },
    selectedLocation: {
      get() {
        return this.$store.getters.selectedLocation;
      }
    },
    userDistance: {
      get() {
        return this.$store.getters.userDistance;
      },
      set(value) {
        this.updateDistance(value);
      }
    },
    userHours: {
      get() {
        return this.$store.getters.userHours;
      },
      set(value) {
        this.updateFilters({
          ...this.userMeta,
          hours: value
        });
      }
    },
    userLocation: {
      get() {
        return this.$store.getters.userLocation;
      }
    },
    userMeta: {
      get() {
        return this.$store.getters.userMeta;
      },
      set(value) {
        this.updateFilters({
          ...this.userMeta,
          meta: value
        });
      }
    },
    userSearch: {
      get() {
        return this.$store.getters.userSearch;
      }
    }
  },
  mixins: [locText],
  methods: {
    ...mapActions([
      "updateDistance",
      "updateFilters",
      "updateHours",
      "updateLocations",
      "updateMeta",
      "updateSelectedLocation",
      "updateUserSearch",
      "geolocateUser"
    ]),
    clearSearch() {
      this.$refs.place.$el.value = "";
    },
    clearFilters() {
      this.distance = this.userDistance = defaultOpt.radius;
      this.hours = this.userHours = null;
      this.meta = this.userMeta = null;

      //clear localstorage?
      //this.resetQueryFilters();
    },
    hideDistanceFilter() {
      this.showDistanceDropdown = false;
    },
    hideHoursFilter() {
      this.showHoursDropdown = false;
    },
    hideServicesFilter() {
      this.showServicesDropdown = false;
    },
    triggerDistanceFilter(value) {
      this.distance = value;
      this.applyRadius();
    },
    triggerHoursFilter(value) {
      this.hours = value;
      this.applyFilters();
    },
    triggerServicesFilter(value) {
      this.meta = value;
      this.applyFilters();
    },
    applyFilters() {
      this.showDistanceDropdown = this.showHoursDropdown = this.showServicesDropdown = false;
      const payload = {
        hours: this.hours,
        meta: this.meta
      };
      this.updateFilters(payload);
    },
    applyRadius() {
      this.showDistanceDropdown = this.showHoursDropdown = this.showServicesDropdown = false;
      let payload = {};

      if (this.userSearch && this.userSearch.lat && this.userSearch.lng) {
        payload.lat = this.userSearch.lat;
        payload.lng = this.userSearch.lng;
      } else if (
        this.userLocation &&
        this.userLocation.lat &&
        this.userLocation.lng
      ) {
        payload.lat = this.userLocation.lat;
        payload.lng = this.userLocation.lng;
      }

      payload.radius = this.distance;
      this.userDistance = this.distance;
      this.updateLocations(payload);
    },
    setPlace(place) {
      // Convert address to lat and lng and save.
      this.searchTerm = place.formatted_address;
      
      if (place.geometry) {
        const payload = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
          radius: "20",
          term: this.searchTerm
        }

        //this.updateLocations(payload);
        this.updateUserSearch(payload);
        this.userDistance = "20";
        EventBus.scrollToTop();
      } 


    },
    setPlaceBySubmit() {
      const el = this.$refs.place.$refs.input;
      const ev = new Event('keydown');

      ev.which = 13;
      ev.keyCode = 13;

      return el.dispatchEvent(ev);
    },
    toggleLabel(event) {
      const parent = document.querySelector('.location-search-container__search')
      if (event.type === 'focus') {
        // For IE support, keep the following add() methods separate
        parent.classList.add('has-focus')
        parent.classList.add('is-floating')
      }
      if (event.type === 'blur') {        
        parent.classList.remove('has-focus')
        if (event.target.value === '') {          
          parent.classList.remove('is-floating')
          //reset to user's location
          this.geolocateUser();
        }
      }
    },
  },
  watch: {
    userDistance(newValue) {
      this.distance = newValue;

      if (typeof HERO_analytics_data_layer != "undefined") {
        var analytics = HERO_analytics_data_layer;

        var event = {
          event: "search_refinement",
          search__type: "location-search",
          search__refinements: "distance|" + this.distance
        };
        if (this.$refs.place.$el.value && this.$refs.place.$el.value.length > 1) {
          event["search__term"] = this.$refs.place.$el.value;
        }
        analytics.pushEventAndData(event);
      }
    },
    userHours(newValue) {
      this.hours = newValue;
      var hourValueTracking = this.hours;
      if (typeof (hourValueTracking) == 'undefined') {
        hourValueTracking = "default"
      }
      if (typeof HERO_analytics_data_layer != "undefined") {
        var analytics = HERO_analytics_data_layer;

        var event = {
          event: "search_refinement",
          search__type: "location-search",
          search__refinements: "hours|" + hourValueTracking
        };
        if (this.$refs.place.$el.value && this.$refs.place.$el.value.length > 1) {
          event["search__term"] = this.$refs.place.$el.value;
        }
        analytics.pushEventAndData(event);
      }
    },
    userMeta(newValue) {
      this.meta = newValue;
      var metaValueTracking = this.meta;
      if (metaValueTracking == null) {
        metaValueTracking = "default"
      }
      if (typeof HERO_analytics_data_layer != "undefined") {
        var analytics = HERO_analytics_data_layer;

        var event = {
          event: "search_refinement",
          search__type: "location-search",
          search__refinements: "services|" + metaValueTracking
        };
        if (this.$refs.place.$el.value && this.$refs.place.$el.value.length > 1) {
          event["search__term"] = this.$refs.place.$el.value;
        }
        analytics.pushEventAndData(event);
      }
    }
  }
};
</script>
